<template>
  <el-form
    :inline="true"
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-card class="box-card">
      <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('addApartmentJZS.apartmentInfo')}}</span>
        <el-form-item style="float: right; padding: 3px 0">
          <el-button type="primary" @click="saveApartment" icon="el-icon-plus">{{$t('addApartmentJZS.saveApartment')}}</el-button>
        </el-form-item>
      </div>
      <el-form-item
        label-position="labelPosition"
        label-width="120px"
        :label="$t('addApartmentJZS.apartmentName')"
        prop="apartmentName"
      >
        <el-input v-model="ruleForm.apartmentName" :placeholder="$t('addApartmentJZS.apartmentName')"></el-input>
      </el-form-item>

      <el-form-item label-position="labelPosition" label-width="80px" :label="$t('addApartmentJZS.area')" prop="province">
          <el-input style="width:180px" v-show="language=='en'" v-model="ruleForm.province" :placeholder="$t('addApartmentFSS.province')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="ruleForm.province"
          :disabled="ruleForm.isDisabled"
          @change="getProvinceValue"
          style="width:180px"
          :placeholder="$t('addApartmentJZS.province')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.provinceList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-position="labelPosition" prop="city">
        <el-input style="width:180px" v-show="language=='en'" v-model="ruleForm.city" :placeholder="$t('addApartmentFSS.city')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="ruleForm.city"
          :disabled="ruleForm.isDisabled"
          @change="getCityValue"
          style="width:180px"
          :placeholder="$t('addApartmentJZS.city')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.cityList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label-position="labelPosition" prop="area">
        <el-input style="width:180px" v-show="language=='en'" v-model="ruleForm.area" :placeholder="$t('addApartmentFSS.area-county')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="ruleForm.area"
          :disabled="ruleForm.isDisabled"
          :placeholder="$t('addApartmentJZS.area-county')"
          style="width:180px"
          prop="area"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.areaList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label-position="labelPosition"
        label-width="120px"
        :label="$t('addApartmentJZS.address')"
        prop="apartmentAddress"
      >
        <el-input
          v-model="ruleForm.apartmentAddress"
          :disabled="ruleForm.isDisabled"
          :placeholder="$t('addApartmentJZS.apartmentAddress')"
          style="width:550px"
        ></el-input>
      </el-form-item>
    </el-card>

    <el-card class="box-card" style="margin-top:15px">
      <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('addApartmentJZS.roomInfo')}}</span>
      </div>
      <el-form-item
        :label="$t('addApartmentJZS.startFloor')"
        label-width="80"
        prop="startFloor"
        :rules="[{ type: 'number', message: this.$t('addApartmentJZS.number-format')}]"
      >
        <el-input
          type="text"
          maxlength="2"
          show-word-limit
          v-model.number="ruleForm.startFloor"
          placeholder
          style="width:100px"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="this.$t('addApartmentJZS.everyFloorCount')"
        label-width="80"
        prop="floorRoomNum"
        :rules="[{ type: 'number', message: this.$t('addApartmentJZS.number-format')}]"
      >
        <el-input
          type="text"
          maxlength="2"
          show-word-limit
          v-model.number="ruleForm.floorRoomNum"
          style="width:100px"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('addApartmentJZS.floorCount')"
        label-width="80"
        prop="floorNum"
        :rules="[{ type: 'number', message: this.$t('addApartmentJZS.number-format')}]"
      >
        <el-input
          type="text"
          maxlength="2"
          show-word-limit
          v-model.number="ruleForm.floorNum"
          placeholder
          style="width:100px"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button-group>
          <!-- <el-button type="primary" icon="el-icon-plus">新增楼栋</el-button> -->
          <el-button type="primary" @click="createRooms" icon="el-icon-plus">{{$t('addApartmentJZS.createRoom')}}</el-button>
          <el-button type="danger" @click="removeRooms" icon="el-icon-delete">{{$t('addApartmentJZS.clearRoom')}}</el-button>
        </el-button-group>
      </el-form-item>

      <div v-for="f in this.ruleForm.floors" :key="f.floorId" class="text item">
        <el-container>
          <el-aside style="overflow-x:hidden;margin-top:2px;width:100px;border:solid 1px #888888;display:flex;justify-content:center;align-items:center;">
              <el-form>
                <el-row>
                    <el-col :span="24" >{{f.floorName}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-button :title="$t('apartmentDetail.deleteFloor')" @click="delFloor(f.floorId)" size="mini" style="color:red;" icon="el-icon-delete"></el-button>
                  </el-col>   
                </el-row>
              </el-form>
          </el-aside>
          <el-main>
            <div v-for="r in f.roomList" :key="r.roomId" class="text item">
              <el-col :span="8" style="height:60px">
                <el-input :placeholder="$t('addApartmentJZS.roomName-input')" v-model="r.roomName" style="width:80%">
                  <el-button slot="append" style="color:red" icon="el-icon-delete" @click="removeRoom(f.floorId,r)"></el-button>
                </el-input>
              </el-col>
            </div>
          </el-main>
        </el-container>
      </div>
    </el-card>
  </el-form>
</template> 
<script>
export default {
  name: "addApartmentJZS",
  // props: {
  //   "idata":Object
  // },
  props: ["idata","tabIndex"],
  data() {
    return {
      language:localStorage.getItem("language"),
      labelPosition: "right",
      ruleForm: {
        apartmentName: "",
        province: "",
        city: "",
        area: "",
        apartmentAddress: "",
        isDisabled: false, //公寓信息是否编辑状态
        startFloor: 1,
        floorRoomNum: 1,
        floorNum: 1,
        floors: []
      },
      rules: {
        apartmentName: [
          { required: true, message:this.$t('addApartmentJZS.apartmentName-input'), trigger: "blur" }
        ],
        apartmentAddress: [
          { required: true, message: this.$t('addApartmentJZS.apartmentAddress-input'), trigger: "blur" }
        ],
        // province: [{ required: true, message: this.$t('addApartmentJZS.province-input'), trigger: "blur" }],
        // city: [{ required: true, message: this.$t('addApartmentJZS.city-input'), trigger: "blur" }],
        // area: [{ required: true, message: this.$t('addApartmentJZS.area-input'), trigger: "blur" }]
      }
    };
  },
  created() {
    this.$store.commit("province", {}); //加载省份
    this.$store.commit("roomType", {}); //加载省份
  },
  methods: {
    saveApartment(event) {
      if(this.ruleForm.floors==""||this.ruleForm.floors==null||this.ruleForm.floors.length==0){
         this.$message({
          message:this.$t('update.createRoomsInfo'),
          type: "warning"
        });
        return false;
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
           var formData = new FormData();  
        if(this.ruleForm.province!=""&&this.ruleForm.province!=null){
         if(this.language=='zh'){
          var provinceObj = this.$store.state.provinceList.find(item => {
            //model就是上面的数据源
            return item.code === this.ruleForm.province; //筛选出匹配数据
          });
          formData.append("province",provinceObj.name);
         }else{
           formData.append("province",this.ruleForm.province);
         }
        }
          
        if(this.ruleForm.city!=""&&this.ruleForm.city!=null){
         if(this.language=='zh'){  
           var cityObj = this.$store.state.cityList.find(item => {
            //model就是上面的数据源
            return item.code === this.ruleForm.city; //筛选出匹配数据
           });
           formData.append("city",cityObj.name);
          }else{
           formData.append("city",this.ruleForm.city);
          } 
        }

        if(this.ruleForm.area!=""&& this.ruleForm.area!=null){  
          if(this.language=='zh'){
            var areaObj = this.$store.state.areaList.find(item => {
             //model就是上面的数据源
             return item.code === this.ruleForm.area; //筛选出匹配数据
            });
          }else{
             formData.append("area",this.ruleForm.area);
          }
        }  
          //整理房间数组
          var buildingList = [];
          var buldingObj = {};
          buldingObj.buildingName = "1b";
          buldingObj.floorList = this.ruleForm.floors;
          buildingList.push(buldingObj);
          formData.append("apartmentNo", 1);
          formData.append("apartmentName", this.ruleForm.apartmentName);
          formData.append("apartmentAddress", this.ruleForm.apartmentAddress);
          formData.append("apartmentType", 1);
          formData.append("roomList", window.JSON.stringify(buildingList));
          this.$server
            .exam("/customer/apartment/addApartment", formData)
            .then(data => {
              if (data.code == 200) {
                this.$message({
                  message: data.message,
                  type: "success"
                });  
                this.$main.removeTab(this.tabIndex);
                 // 跳转公寓列表
                var data = {};
                data.tabName = this.$t('apartmentList.apartmentList');
                data.id = "1";
                data.comp = "apartmentList";
                this.$main.addApartmentTab(data);
              } else {
                this.$message({
                  message: data.message,
                  type: "warning"
                });
              }
            });
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    createRooms(event) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.floors = [];
          var startFloor = this.ruleForm.startFloor;
          var floorRoomNum = this.ruleForm.floorRoomNum;
          var floorNum = this.ruleForm.floorNum;
          for (var i = startFloor; i < (startFloor+floorNum); i++) {
            var floorObj = {};
            floorObj.floorId = i;
            floorObj.floorName =(i>9?i:'0'+i) + this.$t('addApartmentJZS.floor');
            var rooms = [];
            for (var r = 1; r <= floorRoomNum; r++) {
              var roomObj = {};
              roomObj.roomId = r;
              roomObj.roomName =(i>9?i+'':'0'+i)+(r>9?r+'':'0'+r)+ this.$t('addApartmentJZS.room');
              roomObj.roomTypeId = this.$store.state.roomTypeList[0].roomTypeId;
              rooms.push(roomObj);
            }
            floorObj.roomList = rooms;
            this.ruleForm.floors.push(floorObj);
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
   
    removeRooms() {
      this.ruleForm.floors = [];
    },

    delFloor(floorId){
        this.ruleForm.floors = this.ruleForm.floors.filter((item) => {
          return item.floorId!=floorId;
        });
    },
    removeRoom(floorId,obj){
      this.ruleForm.floors  = this.ruleForm.floors.filter((item) => {
        if(item.floorId==floorId){
          item.roomList=item.roomList.filter((str) => {
            return str.roomId!=obj.roomId;
          });
          if(item.roomList==""||item.roomList==null||item.roomList.length==0){
             return "";
          }
        }
        return this.ruleForm.floors;
      });
     
    },
    getCityValue(val) {
      this.$store.commit("area", { cityCode: val }); //加载区（县）
      this.ruleForm.area = "";
    },
    getProvinceValue(val) {
      this.$store.commit("city", { provinceCode: val }); //加载城市
      this.ruleForm.city = "";
      this.ruleForm.area = "";
    }
  }
};
</script>  


// WEBPACK FOOTER //
// src/components/apartment/addApartmentJZS.vue